export default __webpack_public_path__ + "static/summer_containers65-52df741a509363915bb59f2b4f3254d4.webp";